export enum CashbackEventGroups {
    CASHBACK_SUMMARY_DATA = 'CashbackSummaryData',
}
